module.exports = require('./helpers/bundle-url').getBundleURL('dwYZa') + "spidergwen.662a1233.png";